var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0.0488281C2.89543 0.0488281 2 0.944259 2 2.04883V12.0488C2 13.1534 2.89543 14.0488 4 14.0488H10C11.1046 14.0488 12 13.1534 12 12.0488V2.04883C12 0.944259 11.1046 0.0488281 10 0.0488281H4ZM3 2.04883C3 1.49654 3.44772 1.04883 4 1.04883H10C10.5523 1.04883 11 1.49654 11 2.04883V12.0488C11 12.6011 10.5523 13.0488 10 13.0488H4C3.44772 13.0488 3 12.6011 3 12.0488V2.04883Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.04884C0 3.30856 0.402199 2.66222 1 2.31641V12.5488C1 13.9296 2.11929 15.0488 3.5 15.0488H9.73244C9.38663 15.6466 8.74028 16.0488 8 16.0488H3.5C1.567 16.0488 0 14.4818 0 12.5488V4.04884Z",
    fill: "#212121"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.41ba2c518bba86a4b3e67ee69586ff85.svg";
export { ForwardRef as ReactComponent };